import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { API_CONFIG } from '../config/api.config';
import { downloadBlob } from '../../shared/utils/csv-export.util';
import { ReportExportFormat } from '../../shared/utils/report-export.util';

export type ReportExportKind = 'partners' | 'team' | 'subpartners' | 'full';

@Injectable({ providedIn: 'root' })
export class ReportExportsService {
    private http = inject(HttpClient);

    async download(
        kind: ReportExportKind,
        format: ReportExportFormat,
        options: { projectId?: string | null } = {}
    ): Promise<void> {
        let params = new HttpParams().set('format', format);
        const projectId = String(options.projectId || '').trim();
        if (projectId) params = params.set('project_id', projectId);
        const response = await firstValueFrom(
            this.http.get(`${API_CONFIG.API2_URL}/exports/${kind}`, {
                params,
                observe: 'response',
                responseType: 'blob'
            })
        ) as HttpResponse<Blob>;
        const disposition = response.headers.get('content-disposition') || '';
        const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
        const plain = disposition.match(/filename="?([^";]+)"?/i)?.[1];
        const filename = encoded ? decodeURIComponent(encoded) : plain || `nibni-${kind}-${new Date().toISOString().slice(0, 10)}.${format}`;
        downloadBlob(response.body || new Blob(), filename);
    }
}
